import { useState } from "react";
import axios from "axios";
import Checkbox from "../../ui/checkbox/Checkbox";
import Spinner from "../../ui/spinner/Spinner";
import styles from "./OptionsStyles.module.css";
import { isValidPassword } from "../../../auth/userCredentialsUtils";

const ChangePassword = (props) => {
  const [step, setStep] = useState("verify"); // verify | reset

  const [showSpinner, setShowSpinner] = useState(false);

  const [currentPassword, setCurrentPassword] = useState("");
  const [currentPasswordError, setCurrentPasswordError] = useState("");

  const [newPassword, setNewPassword] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");

  const [repeatPassword, setRepeatPassword] = useState("");
  const [repeatPasswordError, setRepeatPasswordError] = useState("");

  const [serverError, setServerError] = useState("");

  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showRepeat, setShowRepeat] = useState(false);

  const clearErrors = () => {
    setCurrentPasswordError("");
    setNewPasswordError("");
    setRepeatPasswordError("");
    setServerError("");
  };

  // STEP 1: verify current password
  const verifyPasswordHandler = async () => {
    clearErrors();

    if (!currentPassword.trim()) {
      setCurrentPasswordError("Please enter your current password.");
      return;
    }

    try {
      setShowSpinner(true);

      const response = await axios.post(
        "php/sign_in/check_password.php",
        { password: currentPassword.trim() },
        { headers: { "Content-Type": "application/json" } },
      );

      console.log("RAW RESPONSE", response);
      console.log("DATA", response.data);

      if (response.data.code !== 200) {
        alert("The server may not be available. Please check your internet connection");
        setServerError(response.data?.message || "Verification failed.");        
        return;
      }

      setStep("reset");

    } catch (error) {

      if (data.code !== 200) {
        alert(data?.message || "Error connecting to server. Please retry.");
        return;
      }

      setServerError(
        data?.message || "Error connecting to server. Please retry.",
      );
    } finally {
      setShowSpinner(false);
    }
  };

  // STEP 2: update password
  const handleChange = async () => {
    clearErrors();

    if (!newPassword || !repeatPassword) {
      setServerError("Both fields must be filled.");
      return;
    }

    if (newPassword === currentPassword) {
      setServerError("New password must be different from current password.");
      return;
    }

    if (!isValidPassword(newPassword)) {
      setNewPasswordError("Invalid password.");
      return;
    }

    if (!isValidPassword(repeatPassword)) {
      setRepeatPasswordError("Invalid password.");
      return;
    }

    if (newPassword !== repeatPassword) {
      setRepeatPasswordError("Passwords do not match.");
      return;
    }

    try {
      setShowSpinner(true);

      const response = await axios.post(
        "php/sign_in/change_password.php",
        { password: newPassword.trim() },
        { headers: { "Content-Type": "application/json" } },
      );

      console.log("RAW RESPONSE", response);
      console.log("DATA", response.data);

      if (response.data.code !== 200) {
        setServerError(response.data?.message || "Update failed.");
        alert(
          "The server may not be available. Please check your internet connection",
        );
        return;
      }
      alert(response.data.message || "Password updated successfully.");
      props.onCompletion();
      //return;

    } catch (error) {

      const data = error?.response?.data;
      alert(
        "The server may not be available. Please check your internet connection",
      );
      setServerError(
        data?.message || "Error connecting to server. Please retry.",
      );
      
    } finally {
      setShowSpinner(false);
    }
  };

  return (
    <div className={styles.classes}>
      <div className={styles.floatRight}>
        <button className={styles.bgRed} onClick={props.onCancel}>
          Cancel
        </button>
      </div>

      <header className={styles.header}>
        <h2>Change your password</h2>
      </header>

      {/* STEP 1 */}
      {step === "verify" && (
        <>
          <p>Please enter your current password</p>

          <div className={styles.inputView}>
            <label>Current Password</label>
            <div className={styles.flex}>
              <input
                type={showCurrent ? "text" : "password"}
                value={currentPassword}
                onChange={(e) => {
                  setCurrentPassword(e.target.value);
                  setCurrentPasswordError("");
                }}
              />
              <Checkbox
                label="Show"
                checked={showCurrent}
                onChange={() => setShowCurrent((prev) => !prev)}
              />
            </div>
            {currentPasswordError && (
              <span className={styles.errorText}>{currentPasswordError}</span>
            )}
          </div>

          {serverError && <p className={styles.errorText}>{serverError}</p>}

          <button className={styles.bgGreen} onClick={verifyPasswordHandler}>
            Submit
          </button>
        </>
      )}

      {/* STEP 2 */}
      {step === "reset" && (
        <>
          <p>Enter your new password</p>

          <div className={styles.inputView}>
            <label>New Password</label>
            <div className={styles.flex}>
              <input
                type={showNew ? "text" : "password"}
                value={newPassword}
                onChange={(e) => {
                  setNewPassword(e.target.value);
                  setNewPasswordError("");
                }}
              />
              <Checkbox
                label="Show"
                checked={showNew}
                onChange={() => setShowNew((prev) => !prev)}
              />
            </div>
            {newPasswordError && (
              <span className={styles.errorText}>{newPasswordError}</span>
            )}
          </div>

          <div className={styles.inputView}>
            <label>Repeat Password</label>
            <div className={styles.flex}>
              <input
                type={showRepeat ? "text" : "password"}
                value={repeatPassword}
                onChange={(e) => {
                  setRepeatPassword(e.target.value);
                  setRepeatPasswordError("");
                }}
              />
              <Checkbox
                label="Show"
                checked={showRepeat}
                onChange={() => setShowRepeat((prev) => !prev)}
              />
            </div>
            {repeatPasswordError && (
              <span className={styles.errorText}>{repeatPasswordError}</span>
            )}
          </div>

          {serverError && <p className={styles.errorText}>{serverError}</p>}

          <button className={styles.bgGreen} onClick={handleChange}>
            Submit
          </button>
        </>
      )}

      {showSpinner && <Spinner />}
    </div>
  );
};

export default ChangePassword;
